
        var result = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/postcss-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js!../../../../../../../../node_modules/sass-resources-loader/lib/loader.js??ref--3-4!./option.component.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/forms/option/option.component.scss
// module id = 948
// module chunks = 0